import { ITaxZonesState } from './types';

export const selectTaxZonesLoaded = (state: ITaxZonesState) => state.taxZonesLoaded;
export const selectSyncState = (state: ITaxZonesState) => state.syncing;
export const selectTaxZones = (state: ITaxZonesState) => state.taxZones;
export const selectSyncError = (state: ITaxZonesState) => state.error;
export const selectCreateInitiatedState = (state: ITaxZonesState) => state.createInitiated;
export const selectUpdateInitiatedState = (state: ITaxZonesState) => state.updateInitiated;
export const selectDeleteInitiatedState = (state: ITaxZonesState) => state.deleteInitiated;
export const selectCreatedState = (state: ITaxZonesState) => state.taxZoneCreated;
export const selectUpdatedState = (state: ITaxZonesState) => state.taxZoneUpdated;
export const selectDeletedState = (state: ITaxZonesState) => state.taxZoneDeleted;
